import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing-module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

import { 
  ApiService, 
  AppMaterialComponentsModule, 
  LicensedDesignProfessionalApiService, 
  LicensedDesignProfessionalGqlService, 
  ZipCodeApiService, ZipCodeGqlService, 
  LicensedDesignProfessionalSearchModule,
  DialogSolutionDeployingComponent
} from '@ebb-v2/ebb-integration';

import { LicensedDesignProfessionalSearchAppComponent } from './app.component';
import { AppLoadService } from './app-load-service';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { APOLLO_PROVIDERS } from './apollo.config';

export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

@NgModule({ declarations: [
       LicensedDesignProfessionalSearchAppComponent,
        DialogSolutionDeployingComponent,
    ],
    imports: [CommonModule, 
        BrowserModule,
        FlexModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        CommonModule,
        AppMaterialComponentsModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        LicensedDesignProfessionalSearchModule,
        NgxMaskDirective, NgxMaskPipe], providers: [
        ApiService, provideNgxMask(),
        AppLoadService,
        { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
        { provide: LicensedDesignProfessionalApiService, useClass: LicensedDesignProfessionalGqlService },
        { provide: ZipCodeApiService, useClass: ZipCodeGqlService },
         ...APOLLO_PROVIDERS,
    ] , bootstrap: [LicensedDesignProfessionalSearchAppComponent],})
export class LicensedDesignProfessionalSearchAppModule {}
